import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function ProductCard({ product, index = 0 }) {
  const { toggleWishlist, inWishlist } = useStore();
  const img = fileUrl(product.images?.[0]);
  const saved = inWishlist(product.id);

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden bg-surface aspect-[4/5]">
        {img ? (
          <img src={img} alt={product.name} className="img-cover transition-transform duration-700 ease-out group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground font-serif-display text-xl">No image</div>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product.id); }}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-pearl/80 backdrop-blur hover:bg-pearl transition-colors"
          aria-label="Save to favorites"
          data-testid={`wishlist-btn-${product.id}`}
        >
          <Heart strokeWidth={1.5} className={`w-4 h-4 ${saved ? "fill-wine text-wine" : "text-ink"}`} />
        </button>
      </Link>
      <div className="pt-4 flex justify-between items-start gap-3">
        <div>
          <Link to={`/product/${product.id}`} className="font-serif-display text-xl leading-tight hover:text-wine transition-colors">{product.name}</Link>
          <p className="label-caps text-muted-foreground mt-1">{product.category}</p>
        </div>
        <p className="font-serif-display text-xl">${product.price?.toFixed(0)}</p>
      </div>
    </motion.div>
  );
}
